import { createFileRoute } from '@tanstack/react-router';
import {
  loadProfileMessages,
  loadProfileScreens,
  notificationSettingsScreen,
  notificationSettingsSearch,
} from '@/modules/profile/route';
import { lazyScreen } from '@/shared/screen';

export const Route = createFileRoute('/_app/meu-perfil/configuracoes/')({
  validateSearch: notificationSettingsSearch,
  staticData: { screen: notificationSettingsScreen },
  loader: () => loadProfileMessages(),
  component: lazyScreen(loadProfileScreens, 'NotificationSettingsScreen'),
});
